export default __webpack_public_path__ + "static/media/searchUser.c4fbc80d.gif";